import React, { Component } from 'react';
import cx from 'classnames';
import { change, Field, Form, formValueSelector, reduxForm } from 'redux-form';
import { lookupTypes } from '../../constants/pnr-lookup-types-enum';
import travelerFormOptions from '../../constants/traveler-form-options';
import FormInputText from '../global/form-input-text';
import TranslatedCopy from '../../intl/translated-copy';
import formFieldCopyIDs from '../../constants/form-field-copy-ids';
import { connect } from 'react-redux';
import pnrLookupValidation from '../../validation/pnr-lookup-validation';
import { CheckInE4 } from '../../../routing/urls';
import { PNR_LOOKUP_FORM_ID } from '../../constants/form-ids';
import Tooltip from './tooltip-my-trips';
import LoggedBar from './logged-bar';

import FormInputDropdown from './form-input-dropdown-new';
import LoadingComponentMyTrips from './loading-component-my-trips';
import { retrieveProfileUserAction } from '../../../redux/actions';
import { chageTouchPointTypeCp } from '../../../redux/actions/change-touch-point-type-cp-creator';

const selector = formValueSelector(PNR_LOOKUP_FORM_ID);

const mapStateToProps = state => {
  return {
    country: state.LanguageBundle.country,
    formValues: state.form['MENU_MY_TRIPS'],
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
    isSignIn: state.UserProfileSession.isSignIn,
    language: state.Manage.language,
    loadingUserInfo: state.UserProfileSession.loadingUserInfo,
    lookupType: selector(state, 'lookupType'),
    remainingAttemptsRetrieveProfile: state.UserProfileSession.remainingAttemptsRetrieveProfile,
    storefront: state.Manage.storefront,
    userProfile: state.UserProfileSession.userProfile,
    userToken: state.UserProfileSession.userToken,
  };
};

class HeaderSubmenuCKN extends Component {
  static defaultProps = {
    menuBookStyle: {},
    valid: false,
    lookupType: false,
  }

  constructor() {
    super();

    this.state = {
      actionPnrLookUp: '',
      isCheckin: false,
      isError: {
        frequentFlyerNumberHM: false,
        lastName:false,
        lastNamePvf: false,
        ticketNumber: false,
      },
      isRouteInProces: false,
      moreThanOneTrip: false,
      noTrips: false,
      // reservationType: 'Reservation',
      trip: {},
      tripMyb: {},
      typePNRLookUp: '',
      width: 0,
    };

    this.updateWindowDimension = this.updateWindowDimension.bind(this);
    this.handleClick = this.handleClickPnrLookUp.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentDidMount() {
    const { dispatch, isSignIn, remainingAttemptsRetrieveProfile } = this.props;

    this.updateWindowDimension();
    window.addEventListener('resize', this.updateWindowDimension);
    dispatch(change('MENU_MY_TRIPS', 'reservationType', travelerFormOptions.RESERVATION_TYPE[0]));
    dispatch(change('MENU_MY_TRIPS', 'programFrequentTraveler', travelerFormOptions.RESERVATION_TYPE[0]));

    if (isSignIn) {
      const { userProfile } = this.props;

      if (userProfile && !userProfile.myTrips && remainingAttemptsRetrieveProfile > 0) {
        this.handleCheckInTrips(userProfile);
      } else {
        this.handleUserTrips();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { pnrCollectionModel } = this.props;
    const { typePNRLookUp, actionPnrLookUp } = this.state;
    const isDistinct = pnrCollectionModel !== nextProps.pnrCollectionModel;
    const isFFNLookup = lookupTypes.FREQUENT_FLYER;

    if ( typePNRLookUp === 'MYB' && actionPnrLookUp === 'FREQUENT_FLYER' ) {
      if ( isDistinct ) {
        this.setState({
          isRouteInProces: false,
        });
      }
    } else if (typePNRLookUp === 'CKN' && actionPnrLookUp === 'FREQUENT_FLYER' && isDistinct && isFFNLookup) {
      this.setState({
        isRouteInProces: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { userProfile } = this.props;

    if (prevProps.userProfile !== userProfile) {
      if (userProfile.myTrips && userProfile.myTrips._collection.length >= 0) {
        if (userProfile.myTrips._collection.length >= 0) {
          const myTripsCollection = userProfile.myTrips._collection;
          const tripCheckin = [];
          const tripMyb = [];

          myTripsCollection.forEach((item) => {
            item.bookedLegCollection._collection.forEach((segment) => {
              if (segment.manageStatus === 'OPEN' || segment.checkinStatus === 'OPEN') {
                if (segment.checkinStatus === 'OPEN') {
                  tripCheckin.push(item);
                } else {
                  tripMyb.push(item);
                }
              }
            });
          });

          if (tripCheckin.length > 0) {
            this.setState({ isCheckin: true });

            tripCheckin.forEach((trip) => {
              this.setState({ trip: trip });
            });
          } else if (tripCheckin.length === 0 && tripMyb.length > 0) {
            this.setState({ moreThanOneTrip: true });

            tripMyb.forEach((trip) => {
              this.setState({ trip: trip });
            });
          } else {
            this.setState({ noTrips: true });
          }
        } else {
          this.setState({ noTrips: true });
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimension);
  }

  render() {
    const {
      bookMenuType,
      className,
      isSignIn,
      menuBookStyle,
      // userToken,
    } = this.props;
    const { isCheckin, moreThanOneTrip, noTrips, trip } = this.state;
    const bookClasses = cx({
      'HeaderMenuBook HeaderMenuBook-menuMyTrips-display': true,
    }, `HeaderMenuBook--${bookMenuType}`, className);

    return (
      <div  className={ bookClasses } style={ menuBookStyle }>
        {
          isSignIn
            &&
          <LoggedBar
            isCheckin={ isCheckin }
            moreThanOneTrip={ moreThanOneTrip }
            noTrips={ noTrips }
            trip={ trip }
          />
        }
        { this.menuMyTrips() }
      </div>
    );
  }

  handleCheckInTrips() {
    const { country, dispatch, language, loadingUserInfo, remainingAttemptsRetrieveProfile, userToken } = this.props;

    if (loadingUserInfo || remainingAttemptsRetrieveProfile < 1) {
      return;
    }

    const pos = {
      'language': language,
      'pos': 'WEB',
      'store': country,
    };

    dispatch( retrieveProfileUserAction( userToken, pos ) );
  }

  handleUserTrips() {
    const { userProfile } = this.props;

    if (userProfile.myTrips) {
      if (userProfile.myTrips && userProfile.myTrips._collection.length >= 0) {
        if (userProfile.myTrips._collection.length >= 0) {
          const myTripsCollection = userProfile.myTrips._collection;
          const tripCheckin = [];
          const tripMyb = [];

          myTripsCollection.forEach((item) => {
            item.bookedLegCollection._collection.forEach((segment) => {
              if (segment.manageStatus === 'OPEN' || segment.checkinStatus === 'OPEN') {
                if (segment.checkinStatus === 'OPEN') {
                  tripCheckin.push(item);
                } else {
                  tripMyb.push(item);
                }
              }
            });
          });

          if (tripCheckin.length > 0) {
            this.setState({ isCheckin: true });

            tripCheckin.forEach((trip) => {
              this.setState({ trip: trip });
            });
          } else if (tripCheckin.length === 0 && tripMyb.length > 0) {
            this.setState({ moreThanOneTrip: true });

            tripMyb.forEach((trip) => {
              this.setState({ trip: trip });
            });
          } else {
            this.setState({ noTrips: true });
          }
        } else {
          this.setState({ noTrips: true });
        }
      }
    }
  }

  menuMyTrips() {
    const { lookupType, title, valid, formValues, isSignedIn, invalid, helperTraslatedCopy } = this.props;
    const { isRouteInProces } = this.state;

    if (formValues === undefined) return null;
    const { frequentFlyerNumberHM, lastName, lastNamePvf, ticketNumber } = this.state.isError;
    const { reservationType } = this.props.formValues.values;

    const lookupToggleOptions = [
      {
        copyID: 'CHECK_IN_RESERVATION_TICKET_NUMBER',
        value: lookupTypes.TICKET,
      },
      {
        copyID: 'PAX_FFP',
        value: lookupTypes.FREQUENT_FLYER,
      },
    ];
    const newDesignInput = cx({
      'FormInput-new-design': true,
      'FormInput-new-design-short': reservationType === 'Program_frecuent_traveler',
    });
    const submitClass = cx({
      'Icon Icon--arrowRight': true,
      'isValid': (valid && formValues.values.lastName !== undefined) || (valid && formValues.values.lastNamePvf !== undefined),
    });
    const invalidForm = !valid && (frequentFlyerNumberHM || frequentFlyerNumberHM === undefined || lastName || lastName === undefined || lastNamePvf || lastNamePvf === undefined || ticketNumber || ticketNumber === undefined);

    const HeaderMenuBookMyTrips = cx ({
      'HeaderMenuBook-myTrips': true,
      'HeaderMenuBook-myTrips--invalidForm': invalidForm,
      'HeaderMenuBook-myTrips-loggedBar': isSignedIn,
    });

    return (
      <div className={`${HeaderMenuBookMyTrips} HeaderMenuBook-myTrips-tablet ${isSignedIn && 'HeaderMenuBook-myTrips-LoggedIn'}`} >
        {
          !isSignedIn &&
          <div className='HeaderMenuBook-myTrips--row HeaderMenuBook-myTrips-tablet--row'>
            <div className='HeaderMenuBook-myTrips--column title HeaderMenuBook-myTrips-tablet--column'>
              <TranslatedCopy copyID={title} className='HeaderMenuBook-myTrips--title HeaderMenuBook-myTrips-tablet--title' />
            </div>
            <div className='HeaderMenuBook-myTrips--column HeaderMenuBook-myTrips-tablet--column'>
              <p className='HeaderMenuBook-myTrips--signIn HeaderMenuBook-myTrips-tablet--signIn'>
                <TranslatedCopy copyID={'APP_SUBMENU_HAVE_TRAVEL'} spaceAfter={ true } />
                <button className='Link HeaderMenuBook-myTrips--signIn--linkBlue HeaderMenuBook-myTrips-tablet--signIn--linkBlue'  
                  onClick={ ()=>{ this.handleClickOpenModal('checkInModal'); }  }>
                  <TranslatedCopy
                    copyID={'APP_SUBMENU_LOGIN'}
                    spaceBefore={ true}
                  />
                </button>
              </p>
            </div>
          </div>
        }
        {
          reservationType !== 'Program_frecuent_traveler' ? (
            <div className='HeaderMenuBook-myTrips-tablet--form'>
              <Form
                className={`HeaderMenuBook-myTrips--form-row HeaderMenuBook-myTrips-tablet--form-row ${/* isSignedIn ? 'HeaderMenuBook-myTrips--isSignedIn' : */ null}`}
                onSubmit={ (e) => this.handleClickPnrLookUp(e) }  >
                <div className='HeaderMenuBook-myTrips--form-rowInputs HeaderMenuBook-myTrips-tablet--form-rowInputs'>
                  <div className='HeaderMenuBook-myTrips-inputContainerDesk HeaderMenuBook-myTrips--InputContainerTablet HeaderMenuBook-myTrips--Dropdown'>
                    <Field
                      component={ FormInputDropdown }
                      buttons={lookupToggleOptions}
                      changeValue = { this.handleChange }
                      isRequired={ true }
                      labelCopyID={ this.renderTicketNumberLabel() }
                      name='reservationType'
                      options={ travelerFormOptions.RESERVATION_TYPE }/>
                  </div>
                  <div className='HeaderMenuBook-myTrips-inputContainerDesk HeaderMenuBook-myTrips--InputContainerTablet HeaderMenuBook-myTrips--withMarginShort'>
                    <Field
                      className={ newDesignInput }
                      component={ FormInputText }
                      handleError ={ this.handleError }
                      isRequired={ lookupType === lookupTypes.TICKET }
                      labelCopyID={ formFieldCopyIDs.reservationTicketNumber }
                      maxLength={ 13 }
                      minLength={6}
                      name='ticketNumber'
                      placeholder={helperTraslatedCopy.getFormatMessageFromcopyId('APP_PH_RESERVATION')}
                      shouldSetErrorWidth={ true }
                      validateNoSpecialCharsOnChange={ true }
                    />
                  </div>
                  <div className='HeaderMenuBook-myTrips-inputContainerDesk HeaderMenuBook-myTrips--theLast HeaderMenuBook-myTrips--InputContainerTablet HeaderMenuBook-myTrips--inTheMiddle'>
                    <Field
                      className={ newDesignInput }
                      component={ FormInputText }
                      handleError ={ this.handleError }
                      isRequired={ true }
                      labelCopyID={ formFieldCopyIDs.lastName }
                      maxLength={ 30 }
                      minLength={2}
                      name='lastName'
                      placeholder={ helperTraslatedCopy.getFormatMessageFromcopyId('APP_PH_LAST_NAME')}
                      shouldSetErrorWidth={ true }
                      // showIconInput= { true }
                      validateNoSpecialCharsOnChange={ true }/>
                  </div>
                  { isRouteInProces ?
                    <div className={`HeaderMenuBook-myTrips--LoadingContainer HeaderMenuBook-myTrips--LoadingContainerTablet HeaderMenuBook-myTrips--btnLoading ${isSignedIn ? 'HeaderMenuBook-myTrips--isSignedIn' : null}`}>
                      <div className='LoggedBar-container--Button-my-trips Icon-loading LoggedBar-container--Button-my-trips-loading '>
                        {  <LoadingComponentMyTrips /> }
                      </div>
                    </div>
                    : <div className={`HeaderMenuBook-myTrips--SubmitContainer HeaderMenuBook-myTrips--SubmitContainerTablet HeaderMenuBook-myTrips--btnSubmit ${isSignedIn ? 'HeaderMenuBook-myTrips--isSignedIn' : null}`}>
                      { !invalid ?  <button type={ 'submit'} className={ submitClass } ></button> :
                        <span className='Icon Icon--arrowRight' ></span>  }
                    </div> }
                </div>
              </Form>
            </div>
          ) : (
            <div className='HeaderMenuBook-myTrips-tablet--form'>
              <Form
                className={`HeaderMenuBook-myTrips--form-row HeaderMenuBook-myTrips-tablet--form-row ${/* isSignedIn ? 'HeaderMenuBook-myTrips--isSignedIn' : */ null}`}
                onSubmit={ (e) => this.handleClickPnrLookUp(e) } >
                <div className='HeaderMenuBook-myTrips--form-rowInputs HeaderMenuBook-myTrips-tablet--form-rowInputs'>
                  <div className='HeaderMenuBook-myTrips--InputContainerDesktop HeaderMenuBook-myTrips--InputContainerTablet HeaderMenuBook-myTrips--Dropdown' >
                    <Field
                      classNamed={ newDesignInput }
                      component={ FormInputDropdown }
                      buttons={lookupToggleOptions }
                      changeValue = { this.handleChange }
                      isRequired={ true }
                      name='reservationType'
                      labelCopyID={ formFieldCopyIDs.findReservation}
                      options={travelerFormOptions.RESERVATION_TYPE }/>
                  </div>
                  <div
                    className='HeaderMenuBook-myTrips--InputContainerDesktop HeaderMenuBook-myTrips--withMargin HeaderMenuBook-myTrips--InputContainerTablet HeaderMenuBook-myTrips--withMargin-reservationType HeaderMenuBook-myTrips--Dropdown'>
                    <Field
                      className= 'HeaderMenuBook-myTrips--Dropdown-large'
                      classNamed={ newDesignInput }
                      component={ FormInputDropdown }
                      buttons={ lookupToggleOptions }
                      changeValue = { this.handleChange }
                      isRequired={ true }
                      name='programFrequentTraveler'
                      labelCopyID={ formFieldCopyIDs.frequentFlyerProgram}
                      options={travelerFormOptions.FREQUENT_FLYER_PROGRAMS }/>
                  </div>
                  <div className='HeaderMenuBook-myTrips--InputContainerDesktop HeaderMenuBook-myTrips--withMarginShort HeaderMenuBook-myTrips--InputContainerTablet'>
                    <Field
                      className={ newDesignInput }
                      component={ FormInputText }
                      handleError ={ this.handleError }
                      isRequired={lookupType === lookupTypes.FREQUENT_FLYER }
                      labelCopyID={ formFieldCopyIDs.numberFrequentTraveler }
                      maxLength={ 30 }
                      name='frequentFlyerNumberHM'
                      placeholder={helperTraslatedCopy.getFormatMessageFromcopyId('APP_PH_NUM_FREQUENT_TRAVELER')}
                      shouldSetErrorWidth={ true }
                      showIconInput= { true }
                      validateNoSpecialCharsOnChange={ true }
                    />
                  </div>
                  <div className='HeaderMenuBook-myTrips--InputContainerDesktop HeaderMenuBook-myTrips--short HeaderMenuBook-myTrips--InputContainerTablet HeaderMenuBook-myTrips--inTheMiddle'>
                    <Field
                      className={ newDesignInput }
                      component={ FormInputText }
                      handleError ={ this.handleError }
                      isRequired={ true }
                      labelCopyID={ formFieldCopyIDs.lastName }
                      maxLength={ 30 }
                      minLength={2}
                      name='lastNamePvf'
                      placeholder={helperTraslatedCopy.getFormatMessageFromcopyId('APP_PH_LAST_NAME')}
                      shouldSetErrorWidth={ true }
                      // showIconInput= { true }
                      validateNoSpecialCharsOnChange={ true }/>
                  </div>
                  { isRouteInProces ?
                    <div className={`HeaderMenuBook-myTrips--LoadingContainer HeaderMenuBook-myTrips--LoadingContainerTablet HeaderMenuBook-myTrips--btnLoading ${isSignedIn ? 'HeaderMenuBook-myTrips--isSignedIn' : null}`}>
                      <div className='LoggedBar-container--Button-my-trips Icon-loading LoggedBar-container--Button-my-trips-loading'>
                        { <LoadingComponentMyTrips /> }
                      </div>
                    </div>
                    : null /* <div className={`HeaderMenuBook-myTrips--SubmitContainer HeaderMenuBook-myTrips--SubmitContainerTablet HeaderMenuBook-myTrips--btnSubmit ${isSignedIn ? 'HeaderMenuBook-myTrips--isSignedIn' : null}`}>
                      { !invalid ?  <button type={ 'submit'} className={ submitClass } ></button> :
                        <span className='Icon Icon--arrowRight' ></span> }
                  </div> */ }
                </div>
              </Form>
            </div>
          )
        }
      </div>
    );
  }

  renderTicketNumberLabel() {
    return (
      <div>
        <TranslatedCopy
          className='PNRLookupForm-ticketNumberLabel'
          copyID='PAX_FIRST_RESERV' />
        {<Tooltip
          labelID='reservation-label'
          copyID='MYB_NEW_MENU_HEADER_TOOLTIP'
          position={{
            'small': 'right',
            'medium': 'right',
            'medium-high': 'right',
            'large': 'right',
          }}
          tooltipID='reservation' /> }
      </div>
    );
  }

  updateWindowDimension() {
    this.setState({ width: window.innerWidth });
  }

  handleClickPnrLookUp(e) {
    e.preventDefault();
    const {
      country,
      formValues: {
        values: {
          lastName,
          ticketNumber,
        },
      },
      language,
    } = this.props;
    const locationCheckInE4 = CheckInE4(language, country);

    this.setState({
      isRouteInProces: true,
    });

    const host = window.location.hostname;
    window.location.replace(`https://${host}/${locationCheckInE4}?last-name=${lastName}&pnr=${ticketNumber}`);
  }

  updateWindowDimension() {
    this.setState({ width: window.innerWidth });
  }

  handleChange(form, field, value) {
    const { dispatch } = this.props;
    dispatch(change(form, field, value));
  }

  handleError(field, error) {
    switch (field) {
      case 'frequentFlyerNumberHM':
        this.setState( { isError: { frequentFlyerNumberHM: error } });
        break;
      case 'ticketNumber':
        this.setState( { isError: { ticketNumber: error } });
        break;
      case 'lastName':
        this.setState( { isError: { lastName: error } });
        break;
      case 'lastNamePvf':
        this.setState( { isError: { lastNamePvf: error } });
        break;
      default:
        break;
    }
  }

  handleClickOpenModal(typeTouchPoint) {
    const { dispatch, openModalLogin } = this.props;

    dispatch(chageTouchPointTypeCp(typeTouchPoint));

    openModalLogin();
  }
}

HeaderSubmenuCKN = reduxForm({
  form: 'MENU_MY_TRIPS',
  initialValues: {
    lookupType: lookupTypes.TICKET,
  },
  validate: pnrLookupValidation,
})(HeaderSubmenuCKN);

HeaderSubmenuCKN = connect(mapStateToProps)(HeaderSubmenuCKN);

export default HeaderSubmenuCKN;
